import React, {useEffect, useRef, useState} from 'react';
import { Link } from 'react-router-dom';
import LandingMenu from "./landing_menu";
import './default.css'
import {Container, Input} from "reactstrap";
import {Button, Nav, Navbar} from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";

const LandingPage = () => {
    const [currentSection, setCurrentSection] = useState(null);
    const [fullName,setFullName] = useState("");
    const [clientEmail,setClientEmail] = useState("");
    const [url,setUrl] = useState("");
    const [clientMessage,setClientMessage] = useState("");
    const [phone,setPhone] = useState("");
    const form = useRef();
    const handleEvent = (e) => {
        if(e.target.name == "fullName"){
            setFullName(e.target.value);
            console.log(fullName);
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        try {
            var emailContent = `
                    Informacion solicitada:
                    - Nombre: ${formData.get('fullName')}
                    - URL: ${formData.get('url')}
                    - Tlf: ${formData.get('phone')}
                    - Correo: ${formData.get('clientEmail')}
                    - Mensaje: ${formData.get('clientMessage')}
                `;
            await axios.post(`${process.env.REACT_APP_PUBLIC_SERVER}/api/sendmail`, {
                from: "mivaletpe@zohomail.eu",
                email:formData.get('clientEmail'),
                subject:"Informacion",
                message:emailContent,
            });
            Swal.fire("Se ha enviado tu solicitud de informacion")
            formData.set('fullName','');
            formData.set('url','');
            formData.set('phone','');
            formData.set('clientEmail','');
            formData.set('clientMessage','');
        } catch (err) {
            Swal.fire("Ha ocurrido un error enviando el correo, intentalo nuevamente")
        }
    };
    function renderContent(newSection) {
        switch (newSection) {
            case 'home':
                return(
                    <section class="pt-7 pt-md-8" id="home">

                        <div class="container">
                            <div class="row">
                                <div class="col-md-8 mx-auto my-auto text-center">
                                    <h1>Bienvenidos a Mi Valet</h1>
                                    <p class="lead mt-4 mb-5">
                                        Tu solución integral para la gestión de valet parking.
                                    </p>
                                    <p><img className="img-fluid" src="https://media.istockphoto.com/id/2159562015/photo/personalized-luxury-valet-service-a-young-businessman-receives-receipt.jpg?s=2048x2048&w=is&k=20&c=RY1-86p9Ai85ZL-Ue90p1vKC8DmRmz-mA9KwjFbBB9Q=" alt="Mockup"/></p>
                                </div>
                            </div>

                        </div>
                    </section>
                );
            case 'mission':
                return (
                    <section class="pb-7" id="mission">
                        <div class="container">
                            <hr class="my-6"/>
                            <div class="row">
                                <div class="col-md-6 mx-auto text-center">
                                    <h4 class="dot-circle font-weight-normal">Nuestra Mision.</h4>
                                </div>
                            </div>

                            <div class="row mt-5">
                                <div class="col-md-6 order-2 order-md-1 my-md-auto">
                                    <h3>Servicio Rapido</h3>
                                    <p class="text-muted lead">
                                        Optimizar los tiempos de entrega y recepción de vehículos, facilitando la experiencia tanto para el cliente como para el valet. Nuestro objetivo es garantizar rapidez, seguridad y trazabilidad en cada servicio brindado. Nos especializamos en ofrecer soluciones tecnológicas que mejoran la coordinación y optimizan las visitas de los clientes a establecimientos, permitiéndoles aprovechar mejor el resto de su día.
                                        .
                                    </p>
                                </div>
                                <div class="col-md-6 order-1 order-md-2">
                                    <img src="https://img.freepik.com/free-photo/medium-shot-valet-parking-car_23-2150274552.jpg" className="img-fluid d-block mx-auto"
                                         alt="Google Design"/>
                                </div>
                                <div class="col-md-6 order-3 mx-auto border-top border-bottom mt-5 mt-md-0 py-4">
                                    <div class="review text-center">
                                        <p class="quote">Tener la confianza de que al salir esta tu vehiculo, sin esperas y sin sorpresas es nuestro punto fuerte.</p>
                                        <div class="mt-4 d-flex flex-row align-items-center justify-content-center">

                                            <span class="text-muted">Diego y Luis, Mi Valet</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <img src="https://2.bp.blogspot.com/-ztL6nh7uSOo/V9Czt9hvk1I/AAAAAAAACjk/N0YUBapRr305VPwzcVCoQSf1pxfjrA3oQCEw/s1600/confianza2.jpg" className="img-fluid d-block mx-auto"
                                         alt="Confianza"/>
                                </div>
                                <div class="col-md-6 my-md-auto">
                                    <h3>Seguridad</h3>
                                    <p class="text-muted lead">
                                        Trabajamos para hacer el proceso fiable ameno y simple. Siempre adaptados a las necesidades cambiantes de nuestro dia a dia
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>
                );
            case 'whoWeAre':
                return (
                    <section class="bg-hero py-8" id="whoWeAre">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-7 mx-auto text-center">
                                    <h2 class="text-white">Somos un equipo multidisciplinario apasionado por la tecnología y su aplicación en soluciones ágiles que simplifican la vida de los usuarios. Desarrollamos este aplicativo pensando en las necesidades del cliente final, aprovechando las herramientas tecnológicas que ya utilizan en su día a día para dar un paso más hacia la digitalización eficiente y accesible.</h2>
                                    <p class="lead text-white my-4">Quieres saber un poco mas?</p>
                                    <a href="#contact" className="btn btn-primary">Contactanos</a>
                                </div>
                            </div>
                        </div>
                    </section>
                );
            case 'vision':
                return (
                    <section class="bg-light py-7" id="vision">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-7 mx-auto">
                                    <h2 class="dot-circle">Nuestros servicios</h2>
                                    <p class="text-muted lead">Nuestra plataforma te permite hacer un proceso integro, desde tener Valets asi como un medio para asegurar el pago de propinas y validar correctamente que el cliente reciba su vehiculo en excelentes condiciones.</p>
                                </div>
                            </div>
                            <div class="row mt-5">
                                <div class="col-md-10 mx-auto">
                                    <div class="row card-services">
                                        <div class="col-md-6 mb-3">
                                            <div class="card">
                                                <div class="card-body text-center">
                                                    <div class="icon-box border-box">
                                                        <div class="icon-box-inner small-xs text-primary">
                                                            <span data-feather="crop" width="30" height="30"></span>
                                                        </div>
                                                    </div>
                                                    <h5 class="mt-0 mb-3">Valet</h5>
                                                    Integracion con multiples empresas de valet parking.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-3">
                                            <div class="card">
                                                <div class="card-body text-center">
                                                    <div class="icon-box border-box">
                                                        <div class="icon-box-inner small-xs text-primary">
                                                            <span data-feather="monitor" width="30" height="30"></span>
                                                        </div>
                                                    </div>
                                                    <h5 class="mt-0 mb-3">Seguridad</h5>
                                                    Permitimos mantener un historial que indique en las condiciones que recibio el vehiculo.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-3">
                                            <div class="card">
                                                <div class="card-body text-center">
                                                    <div class="icon-box border-box">
                                                        <div class="icon-box-inner small-xs text-primary">
                                                            <span data-feather="briefcase" width="30" height="30"></span>
                                                        </div>
                                                    </div>
                                                    <h5 class="mt-0 mb-3">Rapidez</h5>
                                                    Las notificaciones en tiempo real permiten tener a la mano informacion actualizada.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-3">
                                            <div class="card">
                                                <div class="card-body text-center">
                                                    <div class="icon-box border-box">
                                                        <div class="icon-box-inner small-xs text-primary">
                                                            <span data-feather="smartphone" width="30" height="30"></span>
                                                        </div>
                                                    </div>
                                                    <h5 class="mt-0 mb-3">Integracion</h5>
                                                    Seguimiento de los pagos realizados por los clientes, mediante una plataforma sencilla y ligera.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-3">
                                            <div class="card">
                                                <div class="card-body text-center">
                                                    <div class="icon-box border-box">
                                                        <div class="icon-box-inner small-xs text-primary">
                                                            <span data-feather="message-square" width="30" height="30"></span>
                                                        </div>
                                                    </div>
                                                    <h5 class="mt-0 mb-3">Informacion</h5>
                                                    Detalles de transacciones realizadas, tanto para la empresa de valet como el restaurante.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-3">
                                            <div class="card">
                                                <div class="card-body text-center">
                                                    <div class="icon-box border-box">
                                                        <div class="icon-box-inner small-xs text-primary">
                                                            <span data-feather="headphones" width="30" height="30"></span>
                                                        </div>
                                                    </div>
                                                    <h5 class="mt-0 mb-3">Seguimiento</h5>
                                                    Poder llevar un control, acceder a historicos y validar la informacion desde tu movil.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                );
            case 'contact':
                return (
                    <section class="py-7" id="contact">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-6 mx-auto text-center">
                                    <h2>Quieres trabajar con nosotros?</h2>
                                    <div class="divider bg-primary mx-auto"></div>
                                    <p class="text-muted lead">
                                        Podemos ayudarte? Ponte en contacto con nosotros.
                                    </p>
                                </div>
                            </div>
                            <div class="row mt-5">
                                <div class="col-md-8 mx-auto">
                                    <form onSubmit={handleSubmit}>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <Input type="text" name="fullName"  onChange={handleEvent} className="form-control" placeholder="Nombre completo"/>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <Input type="email" name="clientEmail"  className="form-control"
                                                           placeholder="Correo electronico" onChange={(e) => setClientEmail(e.target.value)}/>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <Input type="tel" name="phone" className="form-control"  onChange={(e) => setPhone(e.target.value)} placeholder="Telefono"/>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <Input type="url" name="url" className="form-control"   onChange={(e) => setUrl(e.target.value)} placeholder="Portal web"/>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="form-group">
                                            <Input  className="form-control" name="clientMessage"  onChange={(e) => setClientMessage(e.target.value)}
                                                      placeholder="Cuentanos que podemos hacer?" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="text-center mt-3">
                                            <Button className="btn btn-primary" type="submit">Enviar</Button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </section>
                );
            default:
                return null;
        }
    };
    return (

        <div>
            <Navbar class="navbar navbar-expand-md navbar-light bg-white fixed-top sticky-navigation" bg="white" sticky="top" >
                <Container>
                    <Navbar.Brand href="#"><img src={require("../../../assets/images/logo/mivalet.jpeg")} width="100px" /></Navbar.Brand>
                    <Nav className="me-auto">
                        <Nav.Link class="nav-link page-scroll"  onClick={() => setCurrentSection(renderContent('home'))}>Inicio</Nav.Link>
                        <Nav.Link class="nav-link page-scroll"  onClick={() => setCurrentSection(renderContent('mission'))}>Mision</Nav.Link>
                        <Nav.Link class="nav-link page-scroll"  onClick={() => setCurrentSection(renderContent('vision'))}>Vision</Nav.Link>
                        <Nav.Link class="nav-link page-scroll"  onClick={() => setCurrentSection(renderContent('whoWeAre'))}>Quienes Somos</Nav.Link>
                        <Nav.Link class="nav-link page-scroll"  onClick={() => setCurrentSection(renderContent('contact'))}>Contactanos</Nav.Link>
                    </Nav>
                    <Nav>
                        <div id="signin2"></div>
                    </Nav>
                    <Nav>
                        <Link to={`${process.env.REACT_APP_PUBLIC_URL}/login`} className="btn-sm btn-light"><i className= "icon-user"> </i>Iniciar Sesión</Link>
                    </Nav>
                </Container>
            </Navbar>

            {currentSection === null ? setCurrentSection(renderContent('home')):currentSection}


                <footer className="footer">
                    <p>© 2025 Mi Valet. Todos los derechos reservados.</p>
                </footer>
        </div>
    );
};

export default LandingPage;
